import React from 'react'
import DropDownExit from '../DropDownExit/DropDownExit'
import Style from './TableFixedPage.module.scss'
const TableFixedPage = ({title}) => {
  return (
    <section className={Style.header}>
        <DropDownExit/>
        <div className={Style.title}>{title}</div>
    </section>
  )
}

export default TableFixedPage